import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import LoteriaButton from "./loteriaButton";
import { selectModalidade } from "../reducers/loteria/loteriaActions";
import LoteriaBody from "./loteriaBody";
import { selectConcursoScreen } from "../reducers/concurso/concursoActions";
import { getOrientation } from "../modules/helpers";

import { AnalyticsSetGameType } from "src/reducers/analytics/analyticsActions";

import "./loteria.css";
class Loteria extends Component {
  constructor(props, context) {
    super(props, context);

    this.apostaRef = createRef(null);
    this.topRef = createRef(null);

    this.renderButtons = this.renderButtons.bind(this);
    this.scrollToBetManager = this.scrollToBetManager.bind(this);

    this.state = {
      idUltimoJogo: undefined
    };
  }
  renderButtons() {
    const list = this.props.list || [];

    if (getOrientation() == "portrait" && !this.props.isNewDesign) {
      let modalidadeOptions = list.map((modalidade, i) => {
        return <option value={i}>{modalidade.objTipoJogo.vchNome}</option>;
      });
      return (
        <select
          class="form-control"
          onChange={(e) => this.selectModalidade(list[e.target.value])}
        >
          {/* <option>Escolha uma modalidade</option> */}
          {modalidadeOptions}
        </select>
      );
    }

    const nullSelection = !this.props.modalidade || !this.props.modalidade.objTipoJogo;

    return list.map((modalidade, index) => {
      const selectedByDefault = nullSelection && (index === 0);
      const selected = !nullSelection && (modalidade.objTipoJogo.vchNome === this.props.modalidade.objTipoJogo.vchNome);

      return (
        <LoteriaButton
          value={modalidade.objTipoJogo.vchNome}
          selected={selected || selectedByDefault}
          onClick={() => this.selectModalidade(modalidade)}
        />
      );
    });
  }

  renderBody() {
    return <LoteriaBody
      toggleErrorModal={this.props.toggleErrorModal}
      apostaRef={this.apostaRef} topRef={this.topRef} />;
  }

  goHome() {
    this.props.selectConcursoScreen(0);
  }

  selectModalidade(modalidade) {
    this.props.AnalyticsSetGameType(modalidade.objTipoJogo.vchNome);

    this.props.selectModalidade(modalidade);
    this.scrollToBetManager();
  }

  scrollToBetManager() {
    if (this.apostaRef.current) {
      this.apostaRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  componentDidMount() {
    window["scrollToBetManager"] = this.scrollToBetManager;
  }

  render() {
    //select first

    if ((!this.props.modalidade || !this.props.modalidade.objTipoJogo) && this.props.list && this.props.list.length) {
      this.selectModalidade(this.props.list[0]);
    }

    if (this.props.modalidade && this.props.modalidade.objTipoJogo) {
      const idModalidade = this.props.modalidade.objTipoJogo.sntTipoJogo;
      if (this.state.idUltimoJogo != null && this.state.idUltimoJogo != idModalidade) {
        this.setState({ idUltimoJogo: idModalidade });
        this.scrollToBetManager();
      }
    }

    return (
      <div role="form" className="loteriaBody div-center">
        <div className="col-md-10">
          <section
            className="row title-section"
            style={{
              paddingLeft: "15px",
              maxWidth: "1200px",
              margin: "0 auto",
              marginBottom: "5px",
            }}
            ref={this.topRef}
          >
            <section className="col-md-12">
              <h2 style={{ display: "inline" }}>Modalidades</h2>
              <a
                className={`btn btn-danger`}
                onClick={() => this.goHome()}
                style={{ float: "right", marginRight: "10px" }}
              >
                Voltar
              </a>
            </section>
          </section>
          <div className="concurso-input-container text-center">
            <section className="row concurso-input-container">
              <h2 style={{ display: "none" }}>MODALIDADES</h2>
              <div className="box-footer modalidades">
                {this.renderButtons()}
              </div>
            </section>
          </div>
          {this.renderBody()}
        </div>
      </div>
    );
  }
}


function lotPopFilter(item) {
  return item.objTipoJogo.bitRifa == 0 && item.objTipoJogo.bitBolao == 0;
}

const mapStateToProps = (state) => ({
  list: (state.loteria.objTipoJogo.listModalidade || []).filter(lotPopFilter),
  modalidade: state.loteria.modalidade,
  isNewDesign: state.settings.isNewDesign,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ selectModalidade, selectConcursoScreen, AnalyticsSetGameType }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Loteria);



// WEBPACK FOOTER //
// ./src/loteria/loteria.jsx